"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StarCircleIcon = function StarCircleIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M7.5.175a7.325 7.325 0 1 0 7.325 7.326A7.333 7.333 0 0 0 7.5.175zm3.4 12.287L7.5 10l-3.4 2.462 1.3-3.996L2 6h4.202L7.5 2l1.298 4H13L9.6 8.466z"
    }) : _react["default"].createElement("path", {
      d: "M7.5 0A7.5 7.5 0 1 0 15 7.5 7.509 7.509 0 0 0 7.5 0zm.001 14.1A6.6 6.6 0 1 1 14.1 7.5a6.608 6.608 0 0 1-6.599 6.6zM13 6H8.798L7.5 2 6.202 6H2l3.4 2.466-1.3 3.996L7.5 10l3.4 2.462-1.3-3.996zM7.5 8.766L6.001 9.852l.574-1.769L5.082 7h1.846L7.5 5.238 8.072 7h1.846L8.425 8.083l.574 1.769z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M12 1a11 11 0 1 0 11 11A11 11 0 0 0 12 1zm4.965 18.315l-4.944-3.597-4.944 3.597 1.894-5.813L4 9.916h6.136L12.02 4.1l1.885 5.816H20l-4.93 3.586z"
    }) : _react["default"].createElement("path", {
      d: "M11.5 1A10.5 10.5 0 1 0 22 11.5 10.499 10.499 0 0 0 11.5 1zm0 20.1a9.6 9.6 0 1 1 9.6-9.6 9.61 9.61 0 0 1-9.6 9.6zm8-12.098h-6.094l-1.885-5.817-1.885 5.817H3.5l4.97 3.585L6.578 18.4l4.944-3.597 4.944 3.597-1.895-5.813zm-7.979 4.565l-3.038 2.21 1.164-3.573-3.052-2.202h3.768l1.158-3.574 1.158 3.574h3.746l-3.03 2.205 1.163 3.569z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M15.5 1A14.5 14.5 0 1 0 30 15.5 14.5 14.5 0 0 0 15.5 1zm7.447 25.122l-7.415-5.395-7.416 5.395 2.84-8.719L3.5 12.025h9.204L15.532 3.3l2.827 8.725H27.5l-7.395 5.378z"
  }) : _react["default"].createElement("path", {
    d: "M15.5 1A14.5 14.5 0 1 0 30 15.5 14.5 14.5 0 0 0 15.5 1zm0 28A13.5 13.5 0 1 1 29 15.5 13.515 13.515 0 0 1 15.5 29zm12-16.975h-9.14L15.531 3.3l-2.828 8.725H3.5l7.456 5.378-2.84 8.72 7.416-5.396 7.415 5.395-2.842-8.719zm-6.46 11.473l-5.508-4.007-5.51 4.008 2.11-6.48-5.537-3.995h6.836l2.1-6.481 2.101 6.481h6.793l-5.495 3.998z"
  }));
};

var _default = StarCircleIcon;
exports["default"] = _default;